/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Tooltip from 'tooltip';
import DropDownMenu from '../Common/dropDownMenu';
import Holon from '../Buttons/holon';
import { resultCardId } from '../../utils/string';
import modalTypes from '../../constants/modalTypes';
import { openModal } from '../../actions/modalActions';
import { updateWorkPackage } from '../../actions/workPackageActions';
import { allows } from '../../utils/authorization';
import ChildrenBar from '../Kanban/childrenBar';
import UserInitialsButton from '../Common/userInitialsButton';
import { filterWorkersByAuthority } from '../../selectors/userSelector';

class Feature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDown: {},
      isNameEdtable: false,
      name: props.item.short_name
    };
  }

  openParent = () => {
    const { item, type } = this.props;

    if (item.parent_id) {
      if (type === 'capability') {
        this.props.openModal(modalTypes.capabilityDetail, {
          id: item.parent_id
        });
      } else {
        this.props.openModal(modalTypes.featureDetail, { id: item.parent_id });
      }
    }
  };

  toggleDropDownOwner = (e) => {
    e.stopPropagation();
    const { item, users } = this.props;
    let { dropDown } = this.state;
    if (dropDown.id) {
      dropDown = {};
    } else {
      const { target: element } = e;
      const classes = 'planwall-drop-menu';
      dropDown = {
        users,
        classes,
        result: item,
        elementClicked: element,
        elementAttached: element,
        parent:
          element.closest('#virtualized-stories-list') ||
          element.closest('.story-list'),
        id: item.id,
        type: 'changeOwner',
        closeDropdown: () => this.setState({ dropDown: {} })
      };
    }
    this.setState({ dropDown });
  };

  makeNameEditable = () => this.setState({ isNameEditable: true });

  handleNameChange = (e) => {
    const newValue = e.target.value;
    this.setState((prevState) => ({
      ...prevState,
      name: newValue
    }));
  };

  updateName = () => {
    // eslint-disable-next-line no-shadow
    const { item, updateWorkPackage, updateTemporaryStory } = this.props;
    if (item.id)
      updateWorkPackage(this.props.item.id, {
        short_name: this.state.name
      });
    else
      updateTemporaryStory(item.temporaryId, {
        short_name: this.state.name
      });

    this.setState({ isNameEditable: false });
  };

  showCard = () => {
    const { dropDown, isNameEditable } = this.state;
    const { item, noHolon, defaultOptions, type, users } = this.props;
    const allowEdit = allows('update', item);
    const valueDefaults =
      defaultOptions.value_defaults && defaultOptions.value_defaults.values;
    const riskDefaults =
      defaultOptions.risk_defaults && defaultOptions.risk_defaults.values;
    const sizeDefaults =
      defaultOptions.t_shirt_size_defaults &&
      defaultOptions.t_shirt_size_defaults.values;
    let vrs = item?.result_type?.type_attributes
      ? item.result_type.type_attributes
      : {};
    vrs = item.capability_type ? item.capability_type.type_attributes : vrs;

    const deletedClassName = item.deleted_at ? 'deleted' : '';
    const blockedClassName = item.blocked ? 'blocked-card' : '';

    return (
      <div
        className={`panel feature-panel panel-default wall-row ${blockedClassName} ${deletedClassName}`}
      >
        <div className="panel-heading" style={{ cursor: 'move' }}>
          <div className="panel-title">
            <div className="">
              <a
                onClick={() => {
                  if (item.id && item.id > 0) {
                    if (type === 'capability') {
                      this.props.openModal(modalTypes.capabilityDetail, {
                        id: item.id
                      });
                    } else {
                      this.props.openModal(modalTypes.featureDetail, {
                        id: item.id
                      });
                    }
                  }
                }}
              >
                {item.id ? resultCardId(item) : 'New'}
              </a>
            </div>
            <div className="holon text-center">
              {item.parent_id && !noHolon && <Holon action={this.openParent} />}
            </div>
            <div className="feature-child vrs-container">
              <div className="text-center value">
                {valueDefaults && vrs.value ? valueDefaults[vrs.value][0] : '-'}
              </div>
              <div className="text-center tc">
                {riskDefaults && vrs.tc ? riskDefaults[vrs.tc][0] : '-'}
              </div>
              <div className="text-center risk">
                {riskDefaults && vrs.rroe ? riskDefaults[vrs.rroe][0] : '-'}
              </div>
              <div className="text-center points">
                {sizeDefaults && vrs.size
                  ? sizeDefaults[vrs.size].substring(0, 2)
                  : '-'}
              </div>
            </div>
          </div>
        </div>
        <div
          className="panel-body"
          onClick={allowEdit ? this.makeNameEditable : null}
        >
          {isNameEditable ? (
            <textarea
              value={this.state.name}
              onChange={this.handleNameChange}
              onBlur={this.updateName}
              autoFocus={isNameEditable}
            />
          ) : (
            <p>{item.name || item.short_name}</p>
          )}
        </div>
        <div
          className={`panel-footer ${
            item.level === 1 ? 'result1' : 'greater-result'
          }`}
        >
          {item.level > 1 && (
            <ChildrenBar resultId={item.id} level={item.level} />
          )}
          <div className="card-details initial-button">
            <UserInitialsButton
              className="owner-initials"
              onClick={this.toggleDropDownOwner}
              isDisabled={!allowEdit || !users || users.length === 0}
              userId={item.owner_id}
              users={users}
            />
          </div>
        </div>
        {dropDown && dropDown.id && (
          <DropDownMenu
            type={dropDown.type}
            dropDown={dropDown}
            key={dropDown.id}
          />
        )}
      </div>
    );
  };

  showMiniCard = () => {
    const { item } = this.props;
    const config = { showDelay: 50 };
    Tooltip(config);

    return (
      <div
        className={`mini-result-card ${item.blocked ? 'blocked-card' : ''}`}
        data-tooltip={item.name}
        data-tooltip-positions="left;right;bottom;top;"
      >
        {resultCardId(item)}
      </div>
    );
  };

  render() {
    const { mini } = this.props;

    return mini ? this.showMiniCard() : this.showCard();
  }
}

Feature.propTypes = {
  item: PropTypes.object.isRequired,
  users: PropTypes.array,
  defaultOptions: PropTypes.object,
  mini: PropTypes.bool,
  noHolon: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
  const { item } = ownProps;
  const users = filterWorkersByAuthority(state, item);
  return {
    defaultOptions: state.defaultOptionsReducer.defaultOptions,
    teams: state.teamReducer.teams,
    users
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      updateWorkPackage
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Feature);
